import gql from "graphql-tag"
import { graphql } from "react-apollo"
import PropTypes from "prop-types"

import DepartmentDropdown from "."

const query = gql`
  query DepartmentList($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      departments {
        id
        name
      }
    }
  }
`
const DepartmentDropdownWithData = graphql(query, {
  options: props => ({
    variables: {
      facilityId: props.facilityId,
    },
  }),
  props: ({ data: { error, loading, facility }, ownProps }) => {
    if (error) {
      throw error
    }
    if (loading) {
      return { loading }
    }
    if (!facility) {
      error = Error("No facility with id " + ownProps.facilityId + " available")
      error.number = 204
      throw error
    }
    return {
      departments: [
        {
          label: "All Departments",
          value: null,
        },
      ].concat(
        facility.departments
          .map(dept => ({
            value: dept.id,
            label: dept.name,
          }))
          .sort((deptA, deptB) => deptA.label.localeCompare(deptB.label))
      ),
      ...ownProps,
    }
  },
})(DepartmentDropdown)

DepartmentDropdownWithData.propTypes = {
  facilityId: PropTypes.string.isRequired,
  departmentUpdated: PropTypes.func,
}

export default DepartmentDropdownWithData
